import { _ as _applyDecoratedDescriptor } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Helper from '@ember/component/helper';
import { task } from 'ember-concurrency';

var _class;
let FirstObjectHelper = (_class = class FirstObjectHelper extends Helper {
  constructor(...args) {
    super(...args);
    this.lastArgs = null;
    this.lastValue = null;
  }
  *resolveTask([maybeArray, index]) {
    // Normalizza null/undefined a 0 come fa il ramo sincrono (index ?? 0),
    // altrimenti index===null leggerebbe arr[null] invece di arr[0].
    const idx = index ?? 0;
    if (typeof maybeArray?.then === 'function') {
      const arr = yield maybeArray;
      this.lastValue = Array.isArray(arr) ? arr[idx] ?? null : null;
    } else {
      this.lastValue = Array.isArray(maybeArray) ? maybeArray[idx] ?? null : null;
    }
    // Verifica che l'helper non sia stato distrutto prima di chiamare recompute
    if (!this.isDestroyed && !this.isDestroying) {
      this.recompute();
    }
  }
  compute(args) {
    // Se l'array è una Promise, avvia il task
    if (typeof args[0]?.then === 'function') {
      // Evita di rilanciare il task se gli argomenti non sono cambiati
      if (!this.lastArgs || this.lastArgs[0] !== args[0] || this.lastArgs[1] !== args[1]) {
        this.lastArgs = [...args];
        this.lastValue = null;
        this.resolveTask.perform(args);
      }
      return this.lastValue;
    }
    // Sincrono
    return Array.isArray(args[0]) ? args[0][args[1] ?? 0] ?? null : null;
  }
  willDestroy() {
    super.willDestroy(...arguments);
    // Cancella il task pendente per evitare recompute su helper distrutto
    this.resolveTask.cancelAll();
  }
}, _applyDecoratedDescriptor(_class.prototype, "resolveTask", [task], Object.getOwnPropertyDescriptor(_class.prototype, "resolveTask"), _class.prototype), _class);

export { FirstObjectHelper as default };
//# sourceMappingURL=first-object.js.map
